// Product photos come back as [{ publicId, url, width, height, position }].
// Always render them ordered by `position`.

export function sortedPhotos(photos) {
  return [...(photos || [])].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
}

export function primaryPhoto(photos) {
  const ordered = sortedPhotos(photos);
  return ordered.length ? ordered[0] : null;
}
